<!--
 * @Version      : V1.0
 * @Date         : 2025-03-25 14:08:22
 * @fileName     : 客户档案
 * @Description  :
-->

<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="query-con">
        <el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="客户编号" porp="customerCode">
            <el-input v-model="formInline.customerCode" placeholder="客户编号"></el-input>
          </el-form-item>
          <el-form-item label="客户名称" porp="customerName">
            <el-input v-model="formInline.customerName" placeholder="客户名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button @click="resetData('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="operate py-20 border-box">
      <el-button type="success" @click="addItem()">新增</el-button>
      <!-- <el-button type="primary">导出</el-button>
      <el-button type="primary">导入</el-button> -->
    </div>
    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange" @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">
        <template #operate="{ row }">
          <div>
            <el-button type="text" @click="details(row)">详情</el-button>
            <el-button type="text" @click="edit(row)">修改</el-button>
            <el-button type="text" @click="detele(row)">删除</el-button>
          </div>
        </template>
      </tableComponent>
    </div>
    <curtomer-profile-details ref="curtomerProfileDetailsRefs" @initQueryData="queryData" :title="detailsT" :status="preStatus"></curtomer-profile-details>
  </div>
</template>

<script>
import curtomerProfileDetails from './components/curtomerProfileDetails.vue'
import tableComponent from '@/components/tableComponent/index.vue'
import { queryCustomerProfileApi, queryCustomerProfileDeleteApi } from '@/api/basicInfo/index'
export default {
  components: {
    tableComponent,
    curtomerProfileDetails
  },
  data() {
    return {
      loading: false,
      detailsT:'客户档案详情',
      formInline: {
        customerCode: "",
        customerName: "",
        customerContactPerson: "",
        customerContactPhone: "",
      },
      dataList: [],
      preStatus:'',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "68px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 1,
          title: "客户编号", // 标题名称
          isSort: false, // 是否展示排序按钮
          width: "125px",
          keyName: "customerCode", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 2,
          title: "客户名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "128px",
          keyName: "customerName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 3,
          title: "客户简称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "128px",
          keyName: "customerShortName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 4,
          title: "地址", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "customerAddress", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 5,
          title: "客户联系人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "customerContactPerson", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 6,
          title: "联系电话", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "customerContactPhone", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 7,
          title: "提交人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "createByName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 8,
          title: "创建日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "180px",
          keyName: "createTime", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 9,
          title: "操作", // 标题名称
fixed:"right",
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "150px",
          keyName: "", // 数据的属性值
          align: "left",
          slotName: "operate", // 插槽名,为空字符串时不使用
        }
      ],
      pagination: {
        pageCount: 7, //总页数
        total: 0, //总条目数
        pageSize: 1,//当前页条数
        pageSizes:[10,20,100]
      }
    }
  },
  mounted() {
    this.queryData()
  },
  methods: {
    queryData() {
      this.initData()
    },
    initData(item = {}) {
      let params = {
        pageNum: "1",
        pageSize: "10",
        query: {
          params: {
            customerCode: "",
            customerName: "",
            customerContactPerson: "",
            customerContactPhone: "",
            ...this.formInline
          }
        },
        ...item
      }
      this.loading = true;
      queryCustomerProfileApi(params).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.dataList = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    childSizeChange(page){
      this.initData({pageSize:page})
    },
    childCurrentChange(value){
      this.initData({pageNum:value})
    },
    resetData(formName) {
      this.formInline.customerCode = "";
      this.formInline.customerName = "";
      this.$nextTick(() => {
        this.initData()
      })
    },
    addItem(){
      this.preStatus='add'
      this.detailsT='客户档案新增'
      this.$refs.curtomerProfileDetailsRefs.openDrawer({})
    },
    details(row){
      this.preStatus='view'
      this.detailsT='客户档案详情'
      this.$refs.curtomerProfileDetailsRefs.openDrawer(row)
    },
    edit(row){
      this.preStatus='edit'
      this.detailsT='客户档案编辑'
      this.$refs.curtomerProfileDetailsRefs.openDrawer(row)
    },
    detele(row) {
      this.$confirm('确定要删除该客户？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        queryCustomerProfileDeleteApi({id:row.id}).then(res=>{
          if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
             this.loading = false;
             this.initData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;
  .box-card {
    width: 100%;
  }
  .operate {}
}
</style>
